import { APPLY_EXCEPTIONAL_REFUND_URL, ISSUE_AUTOMATIC_REUND_BY_TRAVELLER_URL, REVERT_CANCELLED_TICKET_URL } from "../../../utils/api-url";
import { getAPIDateFormat } from "../../../utils/date.utils";
import { postCall } from "../../../utils/network.util";
import { isValidArray } from "../../../utils/utilities";
import { roundNumber } from "../../../utils/math.utils";

export const getPnrKey = (row) => {
    return row.actual_pnr || row.pnr;
};

export const groupTicketsByPnr = (tickets) => {
    const groupsByPnr = {};
    const orderedPnrs = [];
    if (!isValidArray(tickets) || tickets.length === 0) {
        return [];
    }
    tickets.forEach((ticket) => {
        const pnrKey = getPnrKey(ticket);
        if (!pnrKey) {
            return;
        }
        if (!groupsByPnr[pnrKey]) {
            groupsByPnr[pnrKey] = [];
            orderedPnrs.push(pnrKey);
        }
        groupsByPnr[pnrKey].push(ticket);
    });
    return orderedPnrs.map((pnrKey) => {
        const seats = groupsByPnr[pnrKey];
        const first = seats[0];
        const totalFare = roundNumber(seats.reduce((sum, s) => {
            const amount = Number(s.amount_paid);
            return sum + (Number.isFinite(amount) ? amount : 0);
        }, 0));
        const seatNumbers = seats.map((s) => s.seat_number).filter(Boolean);
        const hasBlocked = seats.some((s) => s.traveller_status === 'Blocked');
        const allBlocked = seats.every((s) => s.traveller_status === 'Blocked');
        let aggregatedStatus = first.traveller_status;
        if (allBlocked) {
            aggregatedStatus = 'Blocked';
        } else if (hasBlocked) {
            aggregatedStatus = 'Mixed';
        } else {
            aggregatedStatus = 'Confirmed';
        }
        return {
            pnrKey,
            pnr: first.pnr,
            actual_pnr: first.actual_pnr,
            seats,
            seatNumbers,
            seat_number: seatNumbers.join(', '),
            full_name: first.full_name,
            phone_number: first.phone_number,
            location: first.location,
            drop_location: first.drop_location,
            agent_name: first.agent_name,
            booking_time: first.booking_time,
            traveller_status: aggregatedStatus,
            totalFare,
            seatCount: seats.length,
            ticket_id: first.ticket_id,
            agent_id: first.agent_id,
            trip_id: first.trip_id,
            trip_route_id: first.trip_route_id
        };
    });
};

export const issueAutomaticRefundByTraveller=(traveller,onSuccess,onFailure)=>{
    return postCall(ISSUE_AUTOMATIC_REUND_BY_TRAVELLER_URL, {
        traveller:{
            email: traveller.email_id,
            pnr: traveller.pnr,
            operatorId: traveller.travels_name,
            operatorCode: traveller.operator_code,
            doj: getAPIDateFormat(traveller.start_date),
            sourceId: traveller.origin_id,
            destinationId: traveller.destination_id,
            phone_number: traveller.phone_number,
            seat_number: traveller.seat_number,
            traveller_id: traveller.id 
        },
        agentName:global.userName
      }).then((data) => {
        if(data.status === "SUCCESS"){
            let clientPayload = data.payload;
            if(clientPayload.Status==="SUCCESS"){
                return onSuccess(clientPayload.Payload);
            }else{
                return onFailure(clientPayload.Message);
            }
        }else{
            return onFailure("Failed to issue refund!");
        }
      })
      .catch((reason)=> {
        console.log({reason});
        return onFailure("Failed to isse refund!");
      })
}


export const revertCancelledTicket =(ticketId,seatNumber,onSuccess,onFailure,newSeatNumber)=>{
    return postCall(REVERT_CANCELLED_TICKET_URL, {
        ticketId,
        seatNumber,
        newSeatNumber,
        updatedBy:global.userName
    }).then((data)=>{

        if(data.status === "SUCCESS"){
            if(data.payload.Status == "SUCCESS"){
                return onSuccess(data.payload);
            }else{
                return onFailure(data.payload.Message);
            }
        }else{
            return onFailure(data.message);
        }
    }).catch((reason)=>{
        return onFailure("Failed to revert cancelled ticket!");
    })
}


export const exceptionalRefund=(refundDetails,tripId,onSuccess=()=>{},onFailure=()=>{})=>{
    return postCall(APPLY_EXCEPTIONAL_REFUND_URL, {
        refundDetails,
        tripId,
        operatorCode:global.operatorCode
    }).then((data)=>{
        if(data.payload.Status == "SUCCESS"){
            return onSuccess(data);
        }else{
            onFailure("Failed to give refund");
        }
    }).catch((reason)=>{
        return onFailure("Failed to apply exceptional refund!");
    })
}